import Layout from '@/layout'

const homeRouter = {
    path: '/',
    // redirect: '/home',
    component: Layout,
    children: [
        {
            path: '',
            name: 'Home',
            component: () => import('@/views/home/index')
        }
    ]
}

export default homeRouter